import { FormControlLabel, Radio } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export interface ILabel {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  hasError?: boolean
}
export const LabelCustom = styled(FormControlLabel)<ILabel>`
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  width: ${({ width }) => width || '100%'};
`

export const RadioCustom = styled(Radio)`
  color: ${COLORS.blueFonts};

  .MuiSvgIcon-root,
  .Mui-checked {
    color: ${COLORS.blueFonts};
  }
`
